import { z } from 'zod'

import { StringDtoSchema } from '@hcr/api/shared'

export const TranslationsDtoSchema = z.strictObject({
  description: StringDtoSchema.nullable(),
  translation: StringDtoSchema,
})

export type TranslationsDto = z.infer<typeof TranslationsDtoSchema>

export const isTranslationsDto = (x: unknown): x is TranslationsDto => TranslationsDtoSchema.safeParse(x).success
